module.exports = __webpack_public_path__ + "img/land.677b9ad8.png";